// setPostMediaIntersectingData.js
'use strict';
import { REMOVE_OPERATION_DATA, SET_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Update post media scroll data
 * @kind action
 * @param {string} {postId} - post id.
 * @param {boolean} {isIntersecting} - post isIntersecting.
 * @param {number} {top} - ref top.
 * @param {number} {bottom} - ref bottom.
 * @param {number} {inViewportPercentage} - in viewport percentage.
 * @return {Promise} Action promise.
 */
const setPostMediaIntersectingData =
  ({ postId, isIntersecting, top, bottom, inViewportPercentage }) =>
  async dispatch => {
    if (!postId) return dispatch({ type: '' });

    const selectPath = ['post', 'intersecting'];
    if (isIntersecting) {
      return dispatch({
        type: SET_OPERATION_DATA,
        payload: {
          selectPath: [...selectPath, postId],
          data: {
            postId,
            isIntersecting,
            top,
            bottom,
            inViewportPercentage,
          },
        },
      });
    } else {
      return dispatch({
        type: REMOVE_OPERATION_DATA,
        payload: {
          selectPath: [...selectPath, postId],
        },
      });
    }
  };

export default setPostMediaIntersectingData;
